// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IFdBU","badges":"styles_badges__1N2GI"};